import React from 'react';
import { Button, ColorPicker as AriaColorPicker, type ColorPickerProps as AriaColorPickerProps, DialogTrigger } from 'react-aria-components';
import { ColorSwatch } from './ColorSwatch';
import { ColorArea } from './ColorArea';
import { ColorSliderField } from '../../forms/controls/base-fields/ColorSliderField';
import { ColorField } from '../../forms/controls/base-fields/ColorField';
import { cn } from '../utils';
import { Popover } from '../Popover';
import { Dialog } from '../Dialog';

export interface ColorPickerProps extends Omit<AriaColorPickerProps, 'children'> {
	label?: string;
	children?: React.ReactNode;
}

export function ColorPicker({ label, children, ...props }: ColorPickerProps) {
	return (
		<AriaColorPicker {...props}>
			<DialogTrigger>
				<Button
					className={renderProps =>
						cn(
							'flex w-[200px] cursor-default items-center gap-2 rounded text-sm text-gray-800',
							'outline outline-offset-2 outline-blue-600 forced-colors:outline-[Highlight]',
							renderProps.isFocusVisible ? 'outline-2' : 'outline-0'
						)
					}
				>
					<ColorSwatch />
					<span>{label}</span>
				</Button>
				<Popover placement="bottom start">
					<Dialog className="flex flex-col gap-2">
						{children || (
							<>
								<ColorArea colorSpace="hsb" xChannel="saturation" yChannel="brightness" />
								<ColorSliderField colorSpace="hsb" channel="hue" />
								<ColorField label="Hex" />
							</>
						)}
					</Dialog>
				</Popover>
			</DialogTrigger>
		</AriaColorPicker>
	);
}
